import VueRouter from "vue-router";
import routes from "./Routes";

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
